import { Box, CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";
import { useAppSelector } from "./app/hooks";
import { selectTheme } from "./features/theme/themeSlice";
import { darkTheme, lightTheme } from "./theme";
import { useSearchParams } from "react-router-dom";

export const AppTheme = (props: any) => {
  const [searchParams] = useSearchParams();
  const formatHexColor = (color: string | null) => {
    if (color) {
      if (color[0] === "#") {
        return color;
      } else {
        return "#" + color;
      }
    }
    return color;
  };
  const colorParam = formatHexColor(searchParams.get("color"));
  const color = colorParam
    ? colorParam[0] === "#"
      ? colorParam
      : `#${colorParam}`
    : colorParam;
  const sendedColorParam = formatHexColor(searchParams.get("sended_color"));
  const sendedColor = sendedColorParam
    ? sendedColorParam[0] === "#"
      ? sendedColorParam
      : `#${sendedColorParam}`
    : sendedColorParam;
  const darkColorParam = formatHexColor(searchParams.get("dark_color"));
  const darkColor = darkColorParam
    ? darkColorParam[0] === "#"
      ? darkColorParam
      : `#${darkColorParam}`
    : darkColorParam;
  const darkSendedColorParam = formatHexColor(
    searchParams.get("dark_sended_color")
  );
  const darkSendedColor = darkSendedColorParam
    ? darkSendedColorParam[0] === "#"
      ? darkSendedColorParam
      : `#${darkSendedColorParam}`
    : darkSendedColorParam;
  const backgroundParam = formatHexColor(searchParams.get("background"));
  const background = backgroundParam
    ? backgroundParam[0] === "#"
      ? backgroundParam
      : `#${backgroundParam}`
    : backgroundParam;

  const darkBackgroundParam = formatHexColor(
    searchParams.get("dark_background")
  );
  const darkBackground = darkBackgroundParam
    ? darkBackgroundParam[0] === "#"
      ? darkBackgroundParam
      : `#${darkBackgroundParam}`
    : darkBackgroundParam;
  const isDarkMode = useAppSelector(selectTheme);

  const track = !isDarkMode ? "#00000000" : "#ffffff00";
  const thumb = !isDarkMode ? "#00000078" : "#ffffff78";
  const active = !isDarkMode ? "#000000a8" : "#ffffffa8";

  return (
    <ThemeProvider
      theme={
        isDarkMode
          ? darkTheme(darkColor, darkSendedColor, darkBackground)
          : lightTheme(color, sendedColor, background)
      }
    >
      <GlobalStyles
        styles={{
          html: { height: "100%", overflow: "hidden" },
          body: { height: "100%" },
          "#root": { height: "100%" },
        }}
      />
      <CssBaseline />
      <Box
        sx={{
          height: "100%",
          "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
            backgroundColor: track,
            width: 10,
          },
          "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
            borderRadius: 8,
            backgroundColor: thumb,
            border: "3px solid ".concat(track),
          },
          "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus":
            {
              backgroundColor: active,
            },
          "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active":
            {
              backgroundColor: active,
            },
          "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover":
            {
              backgroundColor: active,
            },
          "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
            backgroundColor: track,
          },
        }}
      >
        {props.children}
      </Box>
    </ThemeProvider>
  );
};
